import {
    listStoryMapsByProject,
    getStoryMapDetail,
} from '../../storyMap.service'
import { buildStoryMapLinkCatalog } from './buildStoryMapLinkCatalog'

/**
 * When no board catalog is passed (e.g. task details), load first project story map.
 */
export const loadProjectStoryMapLinkCatalog = async (projectId) => {
    if (!projectId) return []
    const list = await listStoryMapsByProject({
        storyMapId: projectId,
        limit: 1,
        skip: 0,
    })
    const firstId = list?.data?.[0]?.id
    if (!firstId) return []
    const detail = await getStoryMapDetail(String(firstId))
    if (!detail?.success || !detail?.board) return []
    return buildStoryMapLinkCatalog({
        board: detail.board,
        projectId,
    })
}
